export default {
  visibleBySeller: {
    id: 'sav_discussion_message_merchant_only',
    defaultMessage: 'Message visible by the seller only',
  },
  visibleByYou: {
    id: 'sav_discussion_message_you_only',
    defaultMessage: 'Message visible by you only',
  },
  informativeMessage: {
    id: 'sav_platform_reply_not_expected_tag',
    defaultMessage: 'No reply necessary. The below is just FYI',
  },
  visibleByBackmarket: {
    id: 'sav_discussion_message_backmarket_only',
    defaultMessage: 'Message visible by Back Market only',
  },
  customerCareDisplayName: {
    id: 'bo_sellers_customer_care_request_conversation_message_customer_care_sender_display_name',
    defaultMessage: 'Back Market Customer Care',
  },
}
